import inPossession from "@/store/modules/instructions/in-possession";
import outOfPossession from "@/store/modules/instructions/out-of-possession";
import inTransition from "@/store/modules/instructions/in-transition";

const state = () => ({
  mentality: 0,

});

const modules = {
  inPossession,
  outOfPossession,
  inTransition
};

const mutations = {
  updateMentality (state, value) {
    state.mentality = value;
  }
};

export default {
  state,
  modules,
  mutations
};
